export enum TextureCombineMode {
    MODULATE = 0,
    REPLACE = 1,
    ADD = 2,
    SUBTRACT = 3,
    ADD_SIGNED = 4,
    INTERPOLATE = 5,
}
